import request from "@/service";

/* 查询考试学员列表 */
export function getExamUserList(params) {
  return request({
    url: `/study/exam/user/page`,
    method: "get",
    params
  });
}

/* 查询已新增考试学员列表 */
export function getAllExamUserList(params) {
  return request({
    url: `/study/exam/user/userIdList/${params}`,
    method: "get"
  });
}

/* 删除已新增考试学员 */
export function deleteExamUser(params) {
  return request({
    url: `/study/exam/user/delete`,
    method: "delete",
    data: params
  });
}
